// // src/pages/client/ClientProjects.jsx
// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import {
//   FiTrendingUp,
//   FiCalendar,
//   FiUsers,
//   FiFileText,
//   FiDownload,
//   FiFilter,
//   FiSearch,
//   FiClock,
//   FiCheckCircle,
//   FiAlertCircle,
//   FiPlus,
//   FiX,
//   FiDollarSign,
//   FiMapPin,
//   FiTarget,
//   FiClipboard,
// } from "react-icons/fi";
// import { useClient } from "../context/ClientContext";
// import axios from "axios";

// function ClientProjects() {
//   const { client } = useClient();
//   const [projects, setProjects] = useState([]);
//   const [projectSubmissions, setProjectSubmissions] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [showSubmissionModal, setShowSubmissionModal] = useState(false);

//   const projectTypes = [
//     { value: "precision_farming", label: "Precision Farming", icon: FiTarget },
//     { value: "soil_analysis", label: "Soil Analysis", icon: FiClipboard },
//     { value: "crop_monitoring", label: "Crop Monitoring", icon: FiTrendingUp },
//     { value: "irrigation_system", label: "Irrigation System", icon: FiMapPin },
//     { value: "livestock_management", label: "Livestock Management", icon: FiFileText },
//     { value: "greenhouse_automation", label: "Greenhouse Automation", icon: FiTarget },
//     { value: "data_analytics", label: "Data Analytics", icon: FiTrendingUp },
//     { value: "consultation", label: "Consultation", icon: FiClipboard },
//     { value: "other", label: "Other", icon: FiFileText },
//   ];

//   const statuses = [
//     { value: "all", label: "All Projects", color: "gray" },
//     { value: "planning", label: "Planning", color: "blue" },
//     { value: "active", label: "Active", color: "green" },
//     { value: "on-hold", label: "On Hold", color: "yellow" },
//     { value: "completed", label: "Completed", color: "purple" },
//     { value: "archived", label: "Archived", color: "gray" },
//   ];

//   const submissionStatuses = [
//     { value: "submitted", label: "Submitted", color: "blue" },
//     { value: "under_review", label: "Under Review", color: "yellow" },
//     { value: "approved", label: "Approved", color: "green" },
//     { value: "rejected", label: "Rejected", color: "red" },
//     { value: "cancelled", label: "Cancelled", color: "gray" },
//   ];

//   const [submissionData, setSubmissionData] = useState({
//     title: "",
//     description: "",
//     projectType: "precision_farming",
//     budget: "",
//     timeline: "",
//     location: "",
//     farmSize: "",
//     currentPractices: "",
//     challenges: "",
//     goals: "",
//   });

//   useEffect(() => {
//     fetchProjects();
//     fetchProjectSubmissions();
//   }, []);

//   useEffect(() => {
//     filterProjects();
//   }, [projects, searchTerm, statusFilter]);

//   const fetchProjects = async () => {
//     try {
//       const token = localStorage.getItem("agritech-client-token");
//       const response = await axios.get(
//         "https://agri-back-mauve.vercel.app/api/client-portal/projects",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response.data.success) {
//         setProjects(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching projects:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchProjectSubmissions = async () => {
//     try {
//       const token = localStorage.getItem("agritech-client-token");
//       const response = await axios.get(
//         "https://agri-back-mauve.vercel.app/api/client-portal/project-submissions",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response.data.success) {
//         setProjectSubmissions(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching project submissions:", error);
//     }
//   };

//   const filterProjects = () => {
//     let filtered = projects;

//     if (statusFilter !== "all") {
//       filtered = filtered.filter((project) => project.status === statusFilter);
//     }

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (project) =>
//           project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           project.description
//             ?.toLowerCase()
//             .includes(searchTerm.toLowerCase()) ||
//           project.assignedConsultant?.name
//             .toLowerCase()
//             .includes(searchTerm.toLowerCase())
//       );
//     }

//     setFilteredProjects(filtered);
//   };

//   const handleSubmissionChange = (field, value) => {
//     setSubmissionData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleSubmitProject = async () => {
//     // Validate form
//     const requiredFields = [
//       'title', 'description', 'budget', 'timeline',
//       'location', 'farmSize', 'currentPractices',
//       'challenges', 'goals'
//     ];

//     const missingFields = requiredFields.filter(field => !submissionData[field]);

//     if (missingFields.length > 0) {
//       alert(`Please fill in all required fields: ${missingFields.join(', ')}`);
//       return;
//     }

//     try {
//       const token = localStorage.getItem("agritech-client-token");
//       const response = await axios.post(
//         "https://agri-back-mauve.vercel.app/api/client-portal/project-submissions",
//         submissionData,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response.data.success) {
//         setProjectSubmissions((prev) => [response.data.data, ...prev]);
//         setShowSubmissionModal(false);
//         setSubmissionData({
//           title: "",
//           description: "",
//           projectType: "precision_farming",
//           budget: "",
//           timeline: "",
//           location: "",
//           farmSize: "",
//           currentPractices: "",
//           challenges: "",
//           goals: "",
//         });
//         alert("Project submitted successfully! Admin will review your project.");
//       }
//     } catch (error) {
//       console.error("Error submitting project:", error);
//       alert(
//         "Error submitting project: " +
//           (error.response?.data?.message || error.message)
//       );
//     }
//   };

//   const getStatusColor = (status) => {
//     const statusConfig = statuses.find((s) => s.value === status);
//     return statusConfig ? statusConfig.color : "gray";
//   };

//   const getSubmissionStatusColor = (status) => {
//     const statusConfig = submissionStatuses.find((s) => s.value === status);
//     return statusConfig ? statusConfig.color : "gray";
//   };

//   const getStatusIcon = (status) => {
//     switch (status) {
//       case "completed":
//         return <FiCheckCircle className="w-4 h-4" />;
//       case "active":
//         return <FiTrendingUp className="w-4 h-4" />;
//       case "on-hold":
//         return <FiClock className="w-4 h-4" />;
//       default:
//         return <FiCalendar className="w-4 h-4" />;
//     }
//   };

//   const getSubmissionStatusIcon = (status) => {
//     switch (status) {
//       case "submitted":
//         return <FiClock className="w-4 h-4" />;
//       case "under_review":
//         return <FiAlertCircle className="w-4 h-4" />;
//       case "approved":
//         return <FiCheckCircle className="w-4 h-4" />;
//       case "rejected":
//         return <FiX className="w-4 h-4" />;
//       default:
//         return <FiFileText className="w-4 h-4" />;
//     }
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading your projects...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <header className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center h-16">
//             <div className="flex items-center">
//               <h1 className="text-2xl font-bold text-gray-900">
//                 My Projects & Consultations
//               </h1>
//             </div>
//             <div className="flex items-center space-x-4">
//               <div className="text-sm text-gray-500">
//                 {projects.length} active projects • {projectSubmissions.length} submissions
//               </div>
//               <button
//                 onClick={() => setShowSubmissionModal(true)}
//                 className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
//               >
//                 <FiPlus size={16} />
//                 <span>Submit New Project</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Project Submissions Section */}
//         {projectSubmissions.length > 0 && (
//           <div className="mb-8">
//             <h2 className="text-xl font-semibold text-gray-900 mb-4">
//               Project Submissions to Admin
//             </h2>
//             <div className="space-y-4">
//               {projectSubmissions.map((submission, index) => (
//                 <motion.div
//                   key={submission._id}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 }}
//                   className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
//                 >
//                   <div className="flex items-start justify-between mb-4">
//                     <div className="flex-1">
//                       <div className="flex items-center space-x-3 mb-2">
//                         <h3 className="text-lg font-semibold text-gray-900">
//                           {submission.title}
//                         </h3>
//                         <span
//                           className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-${getSubmissionStatusColor(
//                             submission.status
//                           )}-100 text-${getSubmissionStatusColor(
//                             submission.status
//                           )}-800`}
//                         >
//                           {getSubmissionStatusIcon(submission.status)}
//                           <span className="ml-1 capitalize">
//                             {submission.status.replace('_', ' ')}
//                           </span>
//                         </span>
//                       </div>

//                       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm mb-3">
//                         <div className="flex items-center text-gray-600">
//                           <span className="capitalize">
//                             {submission.projectType.replace('_', ' ')}
//                           </span>
//                         </div>
//                         <div className="flex items-center text-gray-600">
//                           <FiDollarSign className="w-4 h-4 mr-2 text-gray-400" />
//                           <span>{submission.budget}</span>
//                         </div>
//                         <div className="flex items-center text-gray-600">
//                           <FiCalendar className="w-4 h-4 mr-2 text-gray-400" />
//                           <span>{submission.timeline}</span>
//                         </div>
//                         <div className="flex items-center text-gray-600">
//                           <FiMapPin className="w-4 h-4 mr-2 text-gray-400" />
//                           <span>{submission.location}</span>
//                         </div>
//                       </div>

//                       {submission.description && (
//                         <p className="text-gray-600 mb-3">
//                           {submission.description}
//                         </p>
//                       )}

//                       {/* Admin Response */}
//                       {submission.adminResponse && (
//                         <div className="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
//                           <div className="flex items-center space-x-2 mb-1">
//                             <span className="text-sm font-medium text-blue-900">
//                               Admin Response:
//                             </span>
//                             <span
//                               className={`text-xs px-2 py-1 rounded-full capitalize ${
//                                 submission.adminResponse?.status === "approved"
//                                   ? "bg-green-100 text-green-800"
//                                   : submission.adminResponse?.status === "rejected"
//                                   ? "bg-red-100 text-red-800"
//                                   : "bg-orange-100 text-orange-800"
//                               }`}
//                             >
//                               {submission.adminResponse?.status?.replace('_', ' ') || "No Response"}
//                             </span>
//                           </div>
//                           {submission.adminResponse?.notes && (
//                             <p className="text-sm text-blue-700">
//                               {submission.adminResponse.notes}
//                             </p>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="flex items-center justify-between text-sm text-gray-500">
//                     <div>
//                       Submitted: {formatDate(submission.createdAt)}
//                     </div>
//                     {submission.farmSize && (
//                       <div>Farm Size: {submission.farmSize}</div>
//                     )}
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Active Projects Section */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
//           <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center">
//             <div className="flex flex-col sm:flex-row gap-4 flex-1">
//               {/* Search */}
//               <div className="relative flex-1 min-w-[300px]">
//                 <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//                 <input
//                   type="text"
//                   placeholder="Search projects..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                 />
//               </div>

//               {/* Status Filter */}
//               <div className="flex items-center gap-2">
//                 <FiFilter className="text-gray-400" />
//                 <select
//                   value={statusFilter}
//                   onChange={(e) => setStatusFilter(e.target.value)}
//                   className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                 >
//                   {statuses.map((status) => (
//                     <option key={status.value} value={status.value}>
//                       {status.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Active Projects Grid */}
//         {filteredProjects.length > 0 ? (
//           <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
//             {filteredProjects.map((project, index) => (
//               <motion.div
//                 key={project._id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow cursor-pointer"
//                 onClick={() => setSelectedProject(project)}
//               >
//                 <div className="p-6">
//                   {/* Project Header */}
//                   <div className="flex items-start justify-between mb-4">
//                     <div>
//                       <h3 className="text-lg font-semibold text-gray-900 mb-2">
//                         {project.title}
//                       </h3>
//                       <div
//                         className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-${getStatusColor(
//                           project.status
//                         )}-100 text-${getStatusColor(project.status)}-800`}
//                       >
//                         {getStatusIcon(project.status)}
//                         <span className="ml-1 capitalize">
//                           {project.status}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="text-right">
//                       <div className="text-2xl font-bold text-green-600">
//                         {project.progress?.percentage || 0}%
//                       </div>
//                       <div className="text-xs text-gray-500">Complete</div>
//                     </div>
//                   </div>

//                   {/* Progress Bar */}
//                   <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
//                     <div
//                       className={`bg-green-600 h-2 rounded-full transition-all duration-500`}
//                       style={{ width: `${project.progress?.percentage || 0}%` }}
//                     ></div>
//                   </div>

//                   {/* Project Description */}
//                   {project.description && (
//                     <p className="text-gray-600 text-sm mb-4 line-clamp-2">
//                       {project.description}
//                     </p>
//                   )}

//                   {/* Project Details */}
//                   <div className="space-y-3 text-sm">
//                     {project.assignedConsultant && (
//                       <div className="flex items-center text-gray-600">
//                         <FiUsers className="w-4 h-4 mr-2 text-gray-400" />
//                         <span>{project.assignedConsultant.name}</span>
//                       </div>
//                     )}

//                     {project.timeline?.startDate && (
//                       <div className="flex items-center text-gray-600">
//                         <FiCalendar className="w-4 h-4 mr-2 text-gray-400" />
//                         <span>
//                           Started: {formatDate(project.timeline.startDate)}
//                         </span>
//                       </div>
//                     )}

//                     {project.timeline?.milestones &&
//                       project.timeline.milestones.length > 0 && (
//                         <div className="flex items-center text-gray-600">
//                           <FiCheckCircle className="w-4 h-4 mr-2 text-gray-400" />
//                           <span>
//                             {
//                               project.timeline.milestones.filter(
//                                 (m) => m.status === "completed"
//                               ).length
//                             }
//                             /{project.timeline.milestones.length} milestones
//                           </span>
//                         </div>
//                       )}

//                     {project.documents && project.documents.length > 0 && (
//                       <div className="flex items-center text-gray-600">
//                         <FiFileText className="w-4 h-4 mr-2 text-gray-400" />
//                         <span>{project.documents.length} documents</span>
//                       </div>
//                     )}
//                   </div>

//                   {/* Action Buttons */}
//                   <div className="mt-4 flex space-x-2">
//                     <button className="flex-1 bg-green-600 text-white py-2 px-3 rounded text-sm hover:bg-green-700 transition-colors flex items-center justify-center">
//                       <FiFileText className="mr-1" size={14} />
//                       View Details
//                     </button>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         ) : (
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-200"
//           >
//             <div className="text-gray-400 text-6xl mb-4">📋</div>
//             <h3 className="text-lg font-medium text-gray-900 mb-2">
//               No active projects found
//             </h3>
//             <p className="text-gray-500 mb-6">
//               {searchTerm || statusFilter !== "all"
//                 ? "Try adjusting your search or filters"
//                 : "You don't have any active projects yet."}
//             </p>
//           </motion.div>
//         )}

//         {/* Project Submission Modal */}
//         {showSubmissionModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//             <motion.div
//               initial={{ opacity: 0, scale: 0.9 }}
//               animate={{ opacity: 1, scale: 1 }}
//               className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
//             >
//               <div className="flex items-center justify-between p-6 border-b border-gray-200">
//                 <h2 className="text-xl font-semibold">Submit New Project to Admin</h2>
//                 <button
//                   onClick={() => setShowSubmissionModal(false)}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   ✕
//                 </button>
//               </div>

//               <div className="p-6">
//                 <div className="space-y-6">
//                   {/* Project Title */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Project Title *
//                     </label>
//                     <input
//                       type="text"
//                       value={submissionData.title}
//                       onChange={(e) => handleSubmissionChange("title", e.target.value)}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                       placeholder="e.g., Smart Irrigation System Installation"
//                       required
//                     />
//                   </div>

//                   {/* Project Type */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Project Type *
//                     </label>
//                     <select
//                       value={submissionData.projectType}
//                       onChange={(e) => handleSubmissionChange("projectType", e.target.value)}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                       required
//                     >
//                       {projectTypes.map((type) => (
//                         <option key={type.value} value={type.value}>
//                           {type.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   {/* Description */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Project Description *
//                     </label>
//                     <textarea
//                       value={submissionData.description}
//                       onChange={(e) => handleSubmissionChange("description", e.target.value)}
//                       rows={4}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
//                       placeholder="Describe your project in detail..."
//                       required
//                     />
//                   </div>

//                   {/* Budget and Timeline */}
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Budget Estimate *
//                       </label>
//                       <input
//                         type="text"
//                         value={submissionData.budget}
//                         onChange={(e) => handleSubmissionChange("budget", e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                         placeholder="e.g., $5,000 - $10,000"
//                         required
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Timeline *
//                       </label>
//                       <input
//                         type="text"
//                         value={submissionData.timeline}
//                         onChange={(e) => handleSubmissionChange("timeline", e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                         placeholder="e.g., 3-6 months"
//                         required
//                       />
//                     </div>
//                   </div>

//                   {/* Location and Farm Size */}
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Location *
//                       </label>
//                       <input
//                         type="text"
//                         value={submissionData.location}
//                         onChange={(e) => handleSubmissionChange("location", e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                         placeholder="e.g., Nakuru County, Kenya"
//                         required
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Farm Size *
//                       </label>
//                       <input
//                         type="text"
//                         value={submissionData.farmSize}
//                         onChange={(e) => handleSubmissionChange("farmSize", e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                         placeholder="e.g., 50 acres"
//                         required
//                       />
//                     </div>
//                   </div>

//                   {/* Current Practices */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Current Farming Practices *
//                     </label>
//                     <textarea
//                       value={submissionData.currentPractices}
//                       onChange={(e) => handleSubmissionChange("currentPractices", e.target.value)}
//                       rows={3}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
//                       placeholder="Describe your current farming methods and practices..."
//                       required
//                     />
//                   </div>

//                   {/* Challenges */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Challenges Faced *
//                     </label>
//                     <textarea
//                       value={submissionData.challenges}
//                       onChange={(e) => handleSubmissionChange("challenges", e.target.value)}
//                       rows={3}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
//                       placeholder="What challenges are you facing that this project aims to solve?"
//                       required
//                     />
//                   </div>

//                   {/* Goals */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Project Goals *
//                     </label>
//                     <textarea
//                       value={submissionData.goals}
//                       onChange={(e) => handleSubmissionChange("goals", e.target.value)}
//                       rows={3}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
//                       placeholder="What do you hope to achieve with this project?"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="mt-6 flex justify-end space-x-3">
//                   <button
//                     onClick={() => setShowSubmissionModal(false)}
//                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleSubmitProject}
//                     className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
//                   >
//                     Submit Project
//                   </button>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         )}

//         {/* Project Detail Modal */}
//         {selectedProject && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//             <motion.div
//               initial={{ opacity: 0, scale: 0.9 }}
//               animate={{ opacity: 1, scale: 1 }}
//               className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
//             >
//               <div className="flex items-center justify-between p-6 border-b border-gray-200">
//                 <h2 className="text-xl font-semibold">
//                   {selectedProject.title}
//                 </h2>
//                 <button
//                   onClick={() => setSelectedProject(null)}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   ✕
//                 </button>
//               </div>

//               <div className="p-6">
//                 {/* Project Overview */}
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
//                   <div className="lg:col-span-2">
//                     <h3 className="text-lg font-medium text-gray-900 mb-3">
//                       Project Overview
//                     </h3>
//                     {selectedProject.description && (
//                       <p className="text-gray-600 mb-4">
//                         {selectedProject.description}
//                       </p>
//                     )}

//                     <div className="grid grid-cols-2 gap-4">
//                       <div>
//                         <div className="text-sm text-gray-500">Status</div>
//                         <div
//                           className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-${getStatusColor(
//                             selectedProject.status
//                           )}-100 text-${getStatusColor(
//                             selectedProject.status
//                           )}-800`}
//                         >
//                           {getStatusIcon(selectedProject.status)}
//                           <span className="ml-1 capitalize">
//                             {selectedProject.status}
//                           </span>
//                         </div>
//                       </div>
//                       <div>
//                         <div className="text-sm text-gray-500">Progress</div>
//                         <div className="text-2xl font-bold text-green-600">
//                           {selectedProject.progress?.percentage || 0}%
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gray-50 rounded-lg p-4">
//                     <h4 className="font-medium text-gray-900 mb-3">
//                       Consultant
//                     </h4>
//                     {selectedProject.assignedConsultant ? (
//                       <div className="flex items-center space-x-3">
//                         <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
//                           <FiUsers className="text-green-600" />
//                         </div>
//                         <div>
//                           <div className="font-medium text-gray-900">
//                             {selectedProject.assignedConsultant.name}
//                           </div>
//                           <div className="text-sm text-gray-500">
//                             {selectedProject.assignedConsultant.email}
//                           </div>
//                         </div>
//                       </div>
//                     ) : (
//                       <p className="text-gray-500 text-sm">
//                         No consultant assigned
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 {/* Milestones */}
//                 {selectedProject.timeline?.milestones &&
//                   selectedProject.timeline.milestones.length > 0 && (
//                     <div className="mb-6">
//                       <h3 className="text-lg font-medium text-gray-900 mb-3">
//                         Project Milestones
//                       </h3>
//                       <div className="space-y-3">
//                         {selectedProject.timeline.milestones.map(
//                           (milestone, index) => (
//                             <div
//                               key={index}
//                               className="flex items-center justify-between p-3 border border-gray-200 rounded-lg"
//                             >
//                               <div className="flex items-center space-x-3">
//                                 <div
//                                   className={`w-8 h-8 rounded-full flex items-center justify-center ${
//                                     milestone.status === "completed"
//                                       ? "bg-green-100 text-green-600"
//                                       : milestone.status === "in-progress"
//                                       ? "bg-blue-100 text-blue-600"
//                                       : "bg-gray-100 text-gray-400"
//                                   }`}
//                                 >
//                                   {milestone.status === "completed" ? (
//                                     <FiCheckCircle size={16} />
//                                   ) : milestone.status === "in-progress" ? (
//                                     <FiClock size={16} />
//                                   ) : (
//                                     <FiCalendar size={16} />
//                                   )}
//                                 </div>
//                                 <div>
//                                   <div className="font-medium text-gray-900">
//                                     {milestone.title}
//                                   </div>
//                                   {milestone.description && (
//                                     <div className="text-sm text-gray-500">
//                                       {milestone.description}
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                               <div className="text-right">
//                                 <div className="text-sm text-gray-500">
//                                   {milestone.dueDate
//                                     ? formatDate(milestone.dueDate)
//                                     : "No due date"}
//                                 </div>
//                                 <div
//                                   className={`text-xs font-medium capitalize ${
//                                     milestone.status === "completed"
//                                       ? "text-green-600"
//                                       : milestone.status === "in-progress"
//                                       ? "text-blue-600"
//                                       : "text-gray-500"
//                                   }`}
//                                 >
//                                   {milestone.status}
//                                 </div>
//                               </div>
//                             </div>
//                           )
//                         )}
//                       </div>
//                     </div>
//                   )}

//                 {/* Documents */}
//                 {selectedProject.documents &&
//                   selectedProject.documents.length > 0 && (
//                     <div>
//                       <h3 className="text-lg font-medium text-gray-900 mb-3">
//                         Project Documents
//                       </h3>
//                       <div className="space-y-2">
//                         {selectedProject.documents.map((doc, index) => (
//                           <div
//                             key={index}
//                             className="flex items-center justify-between p-3 border border-gray-200 rounded-lg"
//                           >
//                             <div className="flex items-center space-x-3">
//                               <FiFileText className="text-gray-400" />
//                               <div>
//                                 <div className="font-medium text-gray-900">
//                                   {doc.title}
//                                 </div>
//                                 <div className="text-sm text-gray-500">
//                                   Uploaded {formatDate(doc.uploadedAt)} •{" "}
//                                   {doc.fileType}
//                                 </div>
//                               </div>
//                             </div>
//                             <button className="text-green-600 hover:text-green-700 p-2">
//                               <FiDownload size={16} />
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//               </div>
//             </motion.div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default ClientProjects;

// src/pages/client/ClientProjects.jsx
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  FiTrendingUp,
  FiCalendar,
  FiUsers,
  FiFileText,
  FiDownload,
  FiFilter,
  FiSearch,
  FiClock,
  FiCheckCircle,
  FiAlertCircle,
  FiPlus,
  FiX,
  FiDollarSign,
  FiMapPin,
  FiTarget,
  FiClipboard,
  FiPaperclip,
  FiMessageSquare,
  FiSend,
  FiEye,
} from "react-icons/fi";
import { useClient } from "../context/ClientContext";
import axios from "axios";

function ClientProjects() {
  const { client } = useClient();
  const [projects, setProjects] = useState([]);
  const [projectSubmissions, setProjectSubmissions] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [selectedProject, setSelectedProject] = useState(null);
  const [showSubmissionModal, setShowSubmissionModal] = useState(false);

  const projectTypes = [
    { value: "precision_farming", label: "Precision Farming", icon: FiTarget },
    { value: "soil_analysis", label: "Soil Analysis", icon: FiClipboard },
    { value: "crop_monitoring", label: "Crop Monitoring", icon: FiTrendingUp },
    { value: "irrigation_system", label: "Irrigation System", icon: FiMapPin },
    {
      value: "livestock_management",
      label: "Livestock Management",
      icon: FiFileText,
    },
    {
      value: "greenhouse_automation",
      label: "Greenhouse Automation",
      icon: FiTarget,
    },
    { value: "data_analytics", label: "Data Analytics", icon: FiTrendingUp },
    { value: "consultation", label: "Consultation", icon: FiClipboard },
    { value: "other", label: "Other", icon: FiFileText },
  ];

  const statuses = [
    { value: "all", label: "All Projects", color: "gray" },
    { value: "planning", label: "Planning", color: "blue" },
    { value: "active", label: "Active", color: "green" },
    { value: "on-hold", label: "On Hold", color: "yellow" },
    { value: "completed", label: "Completed", color: "purple" },
    { value: "archived", label: "Archived", color: "gray" },
  ];

  const submissionStatuses = [
    { value: "submitted", label: "Submitted", color: "blue" },
    { value: "under_review", label: "Under Review", color: "yellow" },
    { value: "approved", label: "Approved", color: "green" },
    { value: "rejected", label: "Rejected", color: "red" },
    { value: "cancelled", label: "Cancelled", color: "gray" },
  ];

  const [submissionData, setSubmissionData] = useState({
    title: "",
    description: "",
    projectType: "precision_farming",
    goals: "",
    location: "",
    timeline: "",
    budget: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);

  const [showAddResponseModal, setShowAddResponseModal] = useState(null);
  const [responseData, setResponseData] = useState({
    message: "",
    document: null,
  });
  const [uploadingResponse, setUploadingResponse] = useState(false);

  // Add these functions
  const handleAddResponse = async (submissionId) => {
    try {
      let documentData = null;
      if (responseData.document) {
        setUploadingResponse(true);
        // Upload document first
        const formData = new FormData();
        formData.append("document", responseData.document);

        const token = localStorage.getItem("agritech-client-token");
        const uploadResponse = await axios.post(
          "https://agri-back-mauve.vercel.app/api/client-portal/project-submissions/upload-document",
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (uploadResponse.data.success) {
          documentData = uploadResponse.data.data;
        }
      }

      const token = localStorage.getItem("agritech-client-token");
      const response = await axios.post(
        `https://agri-back-mauve.vercel.app/api/client-portal/project-submissions/${submissionId}/responses`,
        {
          message: responseData.message,
          document: documentData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setProjectSubmissions((prev) =>
          prev.map((sub) =>
            sub._id === submissionId ? response.data.data : sub
          )
        );
        setShowAddResponseModal(null);
        setResponseData({
          message: "",
          document: null,
        });
        alert("Response added successfully");
      }
    } catch (error) {
      console.error("Error adding response:", error);
      alert(
        "Failed to add response: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setUploadingResponse(false);
    }
  };

  const downloadDocument = (document) => {
    if (document && document.fileUrl) {
      // Create a temporary anchor element to trigger download
      const link = document.createElement("a");
      link.href = document.fileUrl;
      link.target = "_blank";
      link.download = document.originalName || "document";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const cancelSubmission = async (submissionId) => {
    if (
      window.confirm("Are you sure you want to cancel this project submission?")
    ) {
      try {
        const token = localStorage.getItem("agritech-client-token");
        const response = await axios.put(
          `https://agri-back-mauve.vercel.app/api/client-portal/project-submissions/${submissionId}/cancel`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          setProjectSubmissions((prev) =>
            prev.map((sub) =>
              sub._id === submissionId ? response.data.data : sub
            )
          );
          alert("Project submission cancelled successfully");
        }
      } catch (error) {
        console.error("Error cancelling submission:", error);
        alert(
          "Failed to cancel submission: " +
            (error.response?.data?.message || error.message)
        );
      }
    }
  };

  useEffect(() => {
    fetchProjects();
    fetchProjectSubmissions();
  }, []);

  useEffect(() => {
    filterProjects();
  }, [projects, searchTerm, statusFilter]);

  const fetchProjects = async () => {
    try {
      const token = localStorage.getItem("agritech-client-token");
      const response = await axios.get(
        "https://agri-back-mauve.vercel.app/api/client-portal/projects",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setProjects(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectSubmissions = async () => {
    try {
      const token = localStorage.getItem("agritech-client-token");
      const response = await axios.get(
        "https://agri-back-mauve.vercel.app/api/client-portal/project-submissions",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setProjectSubmissions(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching project submissions:", error);
    }
  };

  const filterProjects = () => {
    let filtered = projects;

    if (statusFilter !== "all") {
      filtered = filtered.filter((project) => project.status === statusFilter);
    }

    if (searchTerm) {
      filtered = filtered.filter(
        (project) =>
          project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          project.description
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          project.assignedConsultant?.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
    }

    setFilteredProjects(filtered);
  };

  const handleSubmissionChange = (field, value) => {
    setSubmissionData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        alert("File size must be less than 10MB");
        return;
      }
      setSelectedFile(file);
    }
  };

  const uploadFile = async () => {
    if (!selectedFile) return null;

    setUploadingFile(true);
    try {
      const token = localStorage.getItem("agritech-client-token");
      const formData = new FormData();
      formData.append("document", selectedFile);

      const response = await axios.post(
        "https://agri-back-mauve.vercel.app/api/client-portal/project-submissions/upload-document", // FIXED ROUTE
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error("Error uploading file:", error);
      return null;
    } finally {
      setUploadingFile(false);
    }
  };
  const handleSubmitProject = async () => {
    // Validate form
    const requiredFields = [
      "title",
      "description",
      "goals",
      "location",
      "timeline",
      "budget",
    ];

    const missingFields = requiredFields.filter(
      (field) => !submissionData[field]
    );

    if (missingFields.length > 0) {
      alert(`Please fill in all required fields: ${missingFields.join(", ")}`);
      return;
    }

    try {
      let documentData = null;
      if (selectedFile) {
        documentData = await uploadFile();
        if (!documentData) {
          alert("Failed to upload document. Please try again.");
          return;
        }
      }

      const token = localStorage.getItem("agritech-client-token");
      const response = await axios.post(
        "https://agri-back-mauve.vercel.app/api/client-portal/project-submissions",
        {
          ...submissionData,
          document: documentData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setProjectSubmissions((prev) => [response.data.data, ...prev]);
        setShowSubmissionModal(false);
        setSubmissionData({
          title: "",
          description: "",
          projectType: "precision_farming",
          goals: "",
          location: "",
          timeline: "",
          budget: "",
        });
        setSelectedFile(null);
        alert(
          "Project submitted successfully! Admin will review your project."
        );
      }
    } catch (error) {
      console.error("Error submitting project:", error);
      alert(
        "Error submitting project: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const getStatusColor = (status) => {
    const statusConfig = statuses.find((s) => s.value === status);
    return statusConfig ? statusConfig.color : "gray";
  };

  const getSubmissionStatusColor = (status) => {
    const statusConfig = submissionStatuses.find((s) => s.value === status);
    return statusConfig ? statusConfig.color : "gray";
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "completed":
        return <FiCheckCircle className="w-4 h-4" />;
      case "active":
        return <FiTrendingUp className="w-4 h-4" />;
      case "on-hold":
        return <FiClock className="w-4 h-4" />;
      default:
        return <FiCalendar className="w-4 h-4" />;
    }
  };

  const getSubmissionStatusIcon = (status) => {
    switch (status) {
      case "submitted":
        return <FiClock className="w-4 h-4" />;
      case "under_review":
        return <FiAlertCircle className="w-4 h-4" />;
      case "approved":
        return <FiCheckCircle className="w-4 h-4" />;
      case "rejected":
        return <FiX className="w-4 h-4" />;
      default:
        return <FiFileText className="w-4 h-4" />;
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your projects...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900">
                My Projects & Consultations
              </h1>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-sm text-gray-500">
                {projects.length} active projects • {projectSubmissions.length}{" "}
                submissions
              </div>
              <button
                onClick={() => setShowSubmissionModal(true)}
                className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
              >
                <FiPlus size={16} />
                <span>Submit New Project</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Project Submissions Section */}
        {/* Project Submissions Section */}
        {projectSubmissions.length > 0 && (
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Project Submissions to Admin
            </h2>
            <div className="space-y-4">
              {projectSubmissions.map((submission, index) => (
                <motion.div
                  key={submission._id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center space-x-3">
                          <h3 className="text-lg font-semibold text-gray-900">
                            {submission.title}
                          </h3>
                          <span
                            className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-${getSubmissionStatusColor(
                              submission.status
                            )}-100 text-${getSubmissionStatusColor(
                              submission.status
                            )}-800`}
                          >
                            {getSubmissionStatusIcon(submission.status)}
                            <span className="ml-1 capitalize">
                              {submission.status.replace("_", " ")}
                            </span>
                          </span>
                        </div>

                        {/* Action Buttons */}
                        {submission.status === "submitted" ||
                        submission.status === "under_review" ? (
                          <button
                            onClick={() => cancelSubmission(submission._id)}
                            className="text-red-600 hover:text-red-800 text-sm flex items-center"
                            title="Cancel submission"
                          >
                            <FiX size={14} />
                            <span className="ml-1">Cancel</span>
                          </button>
                        ) : null}
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm mb-3">
                        <div className="flex items-center text-gray-600">
                          <span className="capitalize">
                            {submission.projectType.replace("_", " ")}
                          </span>
                        </div>
                        <div className="flex items-center text-gray-600">
                          <FiCalendar className="w-4 h-4 mr-2 text-gray-400" />
                          <span>{submission.timeline}</span>
                        </div>
                        <div className="flex items-center text-gray-600">
                          <FiMapPin className="w-4 h-4 mr-2 text-gray-400" />
                          <span>{submission.location}</span>
                        </div>
                        <div className="flex items-center text-gray-600">
                          <FiDollarSign className="w-4 h-4 mr-2 text-gray-400" />
                          <span>{submission.budget}</span>
                        </div>
                      </div>

                      {submission.description && (
                        <p className="text-gray-600 mb-3">
                          {submission.description}
                        </p>
                      )}

                      {submission.goals && (
                        <div className="mb-3">
                          <h4 className="font-medium text-gray-900 mb-1">
                            Project Goals:
                          </h4>
                          <p className="text-gray-600 text-sm">
                            {submission.goals}
                          </p>
                        </div>
                      )}

                      {/* Attached Document with Download */}
                      {submission.document && submission.document.fileUrl && (
                        <div className="flex items-center space-x-2 mb-3">
                          <FiPaperclip className="text-gray-400" />
                          <div className="flex items-center space-x-3">
                            <span className="text-sm text-gray-600">
                              {submission.document.originalName}
                            </span>
                            <div className="flex space-x-2">
                              <button
                                onClick={() =>
                                  window.open(
                                    submission.document.fileUrl,
                                    "_blank"
                                  )
                                }
                                className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                                title="View document"
                              >
                                <FiEye size={14} />
                                <span className="ml-1">View</span>
                              </button>
                              <button
                                onClick={() =>
                                  downloadDocument(submission.document)
                                }
                                className="text-green-600 hover:text-green-800 text-sm flex items-center"
                                title="Download document"
                              >
                                <FiDownload size={14} />
                                <span className="ml-1">Download</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Admin Response */}
                      {submission.adminResponse && (
                        <div className="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                          <div className="flex items-center space-x-2 mb-1">
                            <span className="text-sm font-medium text-blue-900">
                              Admin Response:
                            </span>
                            <span
                              className={`text-xs px-2 py-1 rounded-full capitalize ${
                                submission.adminResponse?.status === "approved"
                                  ? "bg-green-100 text-green-800"
                                  : submission.adminResponse?.status ===
                                    "rejected"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-orange-100 text-orange-800"
                              }`}
                            >
                              {submission.adminResponse?.status?.replace(
                                "_",
                                " "
                              ) || "No Response"}
                            </span>
                          </div>
                          {submission.adminResponse?.notes && (
                            <p className="text-sm text-blue-700">
                              {submission.adminResponse.notes}
                            </p>
                          )}
                          {submission.adminResponse?.proposedChanges && (
                            <div className="mt-2">
                              <span className="text-sm font-medium text-blue-900">
                                Proposed Changes:
                              </span>
                              <p className="text-sm text-blue-700">
                                {submission.adminResponse.proposedChanges}
                              </p>
                            </div>
                          )}
                          {submission.adminResponse?.estimatedCost && (
                            <div className="mt-1">
                              <span className="text-sm font-medium text-blue-900">
                                Estimated Cost:{" "}
                              </span>
                              <span className="text-sm text-blue-700">
                                {submission.adminResponse.estimatedCost}
                              </span>
                            </div>
                          )}
                          {submission.adminResponse?.proposedTimeline && (
                            <div className="mt-1">
                              <span className="text-sm font-medium text-blue-900">
                                Proposed Timeline:{" "}
                              </span>
                              <span className="text-sm text-blue-700">
                                {submission.adminResponse.proposedTimeline}
                              </span>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Thread Responses */}
                      {/* Thread Responses */}
                      {submission.responses &&
                        submission.responses.length > 0 && (
                          <div className="mt-4 space-y-3">
                            <div className="flex items-center justify-between">
                              <h4 className="font-medium text-gray-900">
                                Discussion:
                              </h4>
                              <button
                                onClick={() =>
                                  setShowAddResponseModal(submission)
                                }
                                className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700 transition-colors flex items-center"
                              >
                                <FiMessageSquare className="mr-1" size={12} />
                                Add Response
                              </button>
                            </div>
                            {submission.responses.map((response, idx) => (
                              <div
                                key={idx}
                                className={`p-3 rounded-lg ${
                                  response.senderType === "admin"
                                    ? "bg-blue-50 border border-blue-200"
                                    : "bg-gray-50 border border-gray-200"
                                }`}
                              >
                                <div className="flex justify-between items-start mb-2">
                                  <span className="font-medium text-sm text-gray-900">
                                    {response.senderType === "admin"
                                      ? "Admin"
                                      : "You"}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    {formatDate(response.createdAt)}
                                  </span>
                                </div>
                                <p className="text-sm text-gray-700">
                                  {response.message}
                                </p>
                                {response.document &&
                                  response.document.fileUrl && (
                                    <div className="flex items-center space-x-2 mt-2">
                                      <FiPaperclip
                                        className="text-gray-400"
                                        size={12}
                                      />
                                      <div className="flex items-center space-x-3">
                                        <span className="text-xs text-gray-600">
                                          {response.document.originalName}
                                        </span>
                                        <div className="flex space-x-2">
                                          <button
                                            onClick={() =>
                                              window.open(
                                                response.document.fileUrl,
                                                "_blank"
                                              )
                                            }
                                            className="text-blue-600 hover:text-blue-800 text-xs"
                                            title="View document"
                                          >
                                            <FiEye size={12} />
                                          </button>
                                          <button
                                            onClick={() =>
                                              downloadDocument(
                                                response.document
                                              )
                                            }
                                            className="text-green-600 hover:text-green-800 text-xs"
                                            title="Download document"
                                          >
                                            <FiDownload size={12} />
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}

                      {/* Add Response Button (if no responses yet) */}
                      {(!submission.responses ||
                        submission.responses.length === 0) && (
                        <div className="mt-4">
                          <button
                            onClick={() => setShowAddResponseModal(submission)}
                            className="bg-green-600 text-white px-3 py-2 rounded text-sm hover:bg-green-700 transition-colors flex items-center"
                          >
                            <FiMessageSquare className="mr-2" />
                            Start Discussion
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div>Submitted: {formatDate(submission.createdAt)}</div>
                    {submission.updatedAt !== submission.createdAt && (
                      <div>
                        Last updated: {formatDate(submission.updatedAt)}
                      </div>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        )}

        {/* Active Projects Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
          <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center">
            <div className="flex flex-col sm:flex-row gap-4 flex-1">
              {/* Search */}
              <div className="relative flex-1 min-w-[300px]">
                <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search projects..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>

              {/* Status Filter */}
              <div className="flex items-center gap-2">
                <FiFilter className="text-gray-400" />
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-green-500 focus:border-transparent"
                >
                  {statuses.map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Active Projects Grid */}
        {filteredProjects.length > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project._id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => setSelectedProject(project)}
              >
                <div className="p-6">
                  {/* Project Header */}
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {project.title}
                      </h3>
                      <div
                        className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-${getStatusColor(
                          project.status
                        )}-100 text-${getStatusColor(project.status)}-800`}
                      >
                        {getStatusIcon(project.status)}
                        <span className="ml-1 capitalize">
                          {project.status}
                        </span>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-2xl font-bold text-green-600">
                        {project.progress?.percentage || 0}%
                      </div>
                      <div className="text-xs text-gray-500">Complete</div>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
                    <div
                      className={`bg-green-600 h-2 rounded-full transition-all duration-500`}
                      style={{ width: `${project.progress?.percentage || 0}%` }}
                    ></div>
                  </div>

                  {/* Project Description */}
                  {project.description && (
                    <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                      {project.description}
                    </p>
                  )}

                  {/* Project Details */}
                  <div className="space-y-3 text-sm">
                    {project.assignedConsultant && (
                      <div className="flex items-center text-gray-600">
                        <FiUsers className="w-4 h-4 mr-2 text-gray-400" />
                        <span>{project.assignedConsultant.name}</span>
                      </div>
                    )}

                    {project.timeline?.startDate && (
                      <div className="flex items-center text-gray-600">
                        <FiCalendar className="w-4 h-4 mr-2 text-gray-400" />
                        <span>
                          Started: {formatDate(project.timeline.startDate)}
                        </span>
                      </div>
                    )}

                    {project.timeline?.milestones &&
                      project.timeline.milestones.length > 0 && (
                        <div className="flex items-center text-gray-600">
                          <FiCheckCircle className="w-4 h-4 mr-2 text-gray-400" />
                          <span>
                            {
                              project.timeline.milestones.filter(
                                (m) => m.status === "completed"
                              ).length
                            }
                            /{project.timeline.milestones.length} milestones
                          </span>
                        </div>
                      )}

                    {project.documents && project.documents.length > 0 && (
                      <div className="flex items-center text-gray-600">
                        <FiFileText className="w-4 h-4 mr-2 text-gray-400" />
                        <span>{project.documents.length} documents</span>
                      </div>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <div className="mt-4 flex space-x-2">
                    <button className="flex-1 bg-green-600 text-white py-2 px-3 rounded text-sm hover:bg-green-700 transition-colors flex items-center justify-center">
                      <FiFileText className="mr-1" size={14} />
                      View Details
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-200"
          >
            <div className="text-gray-400 text-6xl mb-4">📋</div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              No active projects found
            </h3>
            <p className="text-gray-500 mb-6">
              {searchTerm || statusFilter !== "all"
                ? "Try adjusting your search or filters"
                : "You don't have any active projects yet."}
            </p>
          </motion.div>
        )}

        {/* Project Submission Modal */}
        {showSubmissionModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            >
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h2 className="text-xl font-semibold">
                  Submit New Project to Admin
                </h2>
                <button
                  onClick={() => setShowSubmissionModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>

              <div className="p-6">
                <div className="space-y-6">
                  {/* Project Title */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Project Title *
                    </label>
                    <input
                      type="text"
                      value={submissionData.title}
                      onChange={(e) =>
                        handleSubmissionChange("title", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="e.g., Smart Irrigation System Installation"
                      required
                    />
                  </div>

                  {/* Project Type */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Project Type *
                    </label>
                    <select
                      value={submissionData.projectType}
                      onChange={(e) =>
                        handleSubmissionChange("projectType", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      required
                    >
                      {projectTypes.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Description */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Project Description *
                    </label>
                    <textarea
                      value={submissionData.description}
                      onChange={(e) =>
                        handleSubmissionChange("description", e.target.value)
                      }
                      rows={4}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                      placeholder="Describe your project in detail..."
                      required
                    />
                  </div>

                  {/* Goals */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Project Goals *
                    </label>
                    <textarea
                      value={submissionData.goals}
                      onChange={(e) =>
                        handleSubmissionChange("goals", e.target.value)
                      }
                      rows={3}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                      placeholder="What do you hope to achieve with this project?"
                      required
                    />
                  </div>

                  {/* Location and Timeline */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Location *
                      </label>
                      <input
                        type="text"
                        value={submissionData.location}
                        onChange={(e) =>
                          handleSubmissionChange("location", e.target.value)
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        placeholder="e.g., Nakuru County, Kenya"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Timeline *
                      </label>
                      <input
                        type="text"
                        value={submissionData.timeline}
                        onChange={(e) =>
                          handleSubmissionChange("timeline", e.target.value)
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        placeholder="e.g., 3-6 months"
                        required
                      />
                    </div>
                  </div>

                  {/* Budget - Moved to last position */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Budget Estimate *
                    </label>
                    <input
                      type="text"
                      value={submissionData.budget}
                      onChange={(e) =>
                        handleSubmissionChange("budget", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="e.g., $5,000 - $10,000"
                      required
                    />
                  </div>

                  {/* Document Upload */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Attach Proposal Document (Optional)
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
                      <input
                        type="file"
                        onChange={handleFileSelect}
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        className="hidden"
                        id="project-document"
                      />
                      <label
                        htmlFor="project-document"
                        className="cursor-pointer text-green-600 hover:text-green-700 font-medium"
                      >
                        <FiPaperclip className="inline mr-2" />
                        {selectedFile ? selectedFile.name : "Choose file"}
                      </label>
                      <p className="text-xs text-gray-500 mt-2">
                        PDF, Word, or Image files up to 10MB
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex justify-end space-x-3">
                  <button
                    onClick={() => setShowSubmissionModal(false)}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmitProject}
                    disabled={uploadingFile}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50"
                  >
                    {uploadingFile ? "Uploading..." : "Submit Project"}
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        )}

        {/* Project Detail Modal */}
        {selectedProject && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            >
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h2 className="text-xl font-semibold">
                  {selectedProject.title}
                </h2>
                <button
                  onClick={() => setSelectedProject(null)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>

              <div className="p-6">
                {/* Project Overview */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
                  <div className="lg:col-span-2">
                    <h3 className="text-lg font-medium text-gray-900 mb-3">
                      Project Overview
                    </h3>
                    {selectedProject.description && (
                      <p className="text-gray-600 mb-4">
                        {selectedProject.description}
                      </p>
                    )}

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <div className="text-sm text-gray-500">Status</div>
                        <div
                          className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-${getStatusColor(
                            selectedProject.status
                          )}-100 text-${getStatusColor(
                            selectedProject.status
                          )}-800`}
                        >
                          {getStatusIcon(selectedProject.status)}
                          <span className="ml-1 capitalize">
                            {selectedProject.status}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">Progress</div>
                        <div className="text-2xl font-bold text-green-600">
                          {selectedProject.progress?.percentage || 0}%
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-medium text-gray-900 mb-3">
                      Consultant
                    </h4>
                    {selectedProject.assignedConsultant ? (
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                          <FiUsers className="text-green-600" />
                        </div>
                        <div>
                          <div className="font-medium text-gray-900">
                            {selectedProject.assignedConsultant.name}
                          </div>
                          <div className="text-sm text-gray-500">
                            {selectedProject.assignedConsultant.email}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p className="text-gray-500 text-sm">
                        No consultant assigned
                      </p>
                    )}
                  </div>
                </div>

                {/* Milestones */}
                {selectedProject.timeline?.milestones &&
                  selectedProject.timeline.milestones.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-medium text-gray-900 mb-3">
                        Project Milestones
                      </h3>
                      <div className="space-y-3">
                        {selectedProject.timeline.milestones.map(
                          (milestone, index) => (
                            <div
                              key={index}
                              className="flex items-center justify-between p-3 border border-gray-200 rounded-lg"
                            >
                              <div className="flex items-center space-x-3">
                                <div
                                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                                    milestone.status === "completed"
                                      ? "bg-green-100 text-green-600"
                                      : milestone.status === "in-progress"
                                      ? "bg-blue-100 text-blue-600"
                                      : "bg-gray-100 text-gray-400"
                                  }`}
                                >
                                  {milestone.status === "completed" ? (
                                    <FiCheckCircle size={16} />
                                  ) : milestone.status === "in-progress" ? (
                                    <FiClock size={16} />
                                  ) : (
                                    <FiCalendar size={16} />
                                  )}
                                </div>
                                <div>
                                  <div className="font-medium text-gray-900">
                                    {milestone.title}
                                  </div>
                                  {milestone.description && (
                                    <div className="text-sm text-gray-500">
                                      {milestone.description}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="text-right">
                                <div className="text-sm text-gray-500">
                                  {milestone.dueDate
                                    ? formatDate(milestone.dueDate)
                                    : "No due date"}
                                </div>
                                <div
                                  className={`text-xs font-medium capitalize ${
                                    milestone.status === "completed"
                                      ? "text-green-600"
                                      : milestone.status === "in-progress"
                                      ? "text-blue-600"
                                      : "text-gray-500"
                                  }`}
                                >
                                  {milestone.status}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  )}

                {/* Documents */}
                {selectedProject.documents &&
                  selectedProject.documents.length > 0 && (
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 mb-3">
                        Project Documents
                      </h3>
                      <div className="space-y-2">
                        {selectedProject.documents.map((doc, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between p-3 border border-gray-200 rounded-lg"
                          >
                            <div className="flex items-center space-x-3">
                              <FiFileText className="text-gray-400" />
                              <div>
                                <div className="font-medium text-gray-900">
                                  {doc.title}
                                </div>
                                <div className="text-sm text-gray-500">
                                  Uploaded {formatDate(doc.uploadedAt)} •{" "}
                                  {doc.fileType}
                                </div>
                              </div>
                            </div>
                            <button className="text-green-600 hover:text-green-700 p-2">
                              <FiDownload size={16} />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </div>
            </motion.div>
          </div>
        )}
      </div>
      {/* Add Response Modal for Client */}
      {showAddResponseModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
          >
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200">
              <h2 className="text-lg sm:text-xl font-semibold">
                Add Response - {showAddResponseModal.title}
              </h2>
              <button
                onClick={() => setShowAddResponseModal(null)}
                className="text-gray-400 hover:text-gray-600"
              >
                <FiX size={20} />
              </button>
            </div>

            <div className="p-4 sm:p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Your Message *
                </label>
                <textarea
                  value={responseData.message}
                  onChange={(e) =>
                    setResponseData((prev) => ({
                      ...prev,
                      message: e.target.value,
                    }))
                  }
                  rows={4}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                  placeholder="Type your response message..."
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Attach Document (Optional)
                </label>
                <input
                  type="file"
                  onChange={(e) =>
                    setResponseData((prev) => ({
                      ...prev,
                      document: e.target.files[0],
                    }))
                  }
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
                {responseData.document && (
                  <p className="text-sm text-gray-600 mt-1">
                    Selected: {responseData.document.name}
                  </p>
                )}
              </div>

              <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-3 pt-4">
                <button
                  onClick={() => setShowAddResponseModal(null)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleAddResponse(showAddResponseModal._id)}
                  disabled={!responseData.message.trim() || uploadingResponse}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50"
                >
                  {uploadingResponse ? "Uploading..." : "Send Response"}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}

export default ClientProjects;
